





























































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import TemplatesModule from "@/store/modules/templates";
import Template from "@/models/template";
import ConfigurationItemGroup from "@/components/ConfigurationItemGroup.vue";
import ComponentsList from "@/components/ComponentsList.vue";
import ComponentsListFronts from "@/components/ComponentsListFronts.vue";
import { IItemSection, SectionType } from "@/models/itemSection";
import {
  PresetMenuItem,
  presets,
  PresetType,
  PresetStep,
} from "@/models/presets";
import store from "@/store";
import { base64Warehouse } from "@/models/base64warehouse";
import { stringUtil } from "@/models/stringUtil.ts";
import { messager } from "@/models/messager.ts";
import { ElementType } from "@/models/element";
import SvgIcon from "@/components/SvgIcon.vue";

@Component({
  components: {
    ConfigurationItemGroup,
    ComponentsList,
    ComponentsListFronts,
    SvgIcon,
  },
})
export default class ConfigurationMenu extends Vue {
  @Prop({ type: Boolean, required: true }) visibility!: Boolean;
  @Prop({ type: Array, required: true }) sections!: IItemSection[];

  private unit: string = "cm";
  private panel: number = 0;

  @Watch("visibility", { immediate: true, deep: true })
  onVisibilityChange(isVisible: Boolean) {}

  @Watch("panel")
  onPanelChange() {
    this.$store.commit("clearSceneState");
  }

  private presets = presets;
  private usePreset = true;

  private readonly avatarSize: number =
    this.$store.getters.configuration.tiny === "true" ? 55 : 70;

  private get currentPresets() {
    return this.presets.presetItems.filter(
      (x) =>
        x.step == PresetStep.COMPLEX &&
        x.productName.toLowerCase() ==
          this.$store.getters.configuration.productId
    );
  }

  private get width(): string {
    const w = this.$store.getters.productFullWidth;
    const width = w % 10 ? `${(w / 10).toFixed(1)}` : `${(w / 10).toFixed(0)}`;
    return width.replace(".", ",");
  }

  private get depth(): string {
    const d = this.$store.getters.productFullDepth;
    const width = d % 10 ? `${(d / 10).toFixed(1)}` : `${(d / 10).toFixed(0)}`;
    return width.replace(".", ",");
  }

  private get height(): string {
    const h = this.$store.getters.productFullHeight;
    const width = h % 10 ? `${(h / 10).toFixed(1)}` : `${(h / 10).toFixed(0)}`;
    return width.replace(".", ",");
  }

  private getAvatar(url: string) {
    var base = base64Warehouse.getAvatar(url);
    return base ? base : stringUtil.createDownloadUrl(url);
  }

  private haveToUseSvg(preset: PresetMenuItem): boolean {
    return preset.type === PresetType.NEW;
  }

  private getClass(preset: PresetMenuItem): string {
    let result = "clickable";
    if (this.$store.getters.scene.tasks) result += " disabled";
    if (preset.selected) result += " selected";
    if (!this.canLoadPresets) result += " disabled";
    return result;
  }

  private setPreset(preset: PresetMenuItem, complex: boolean) {
    this.usePreset = complex;
    this.presets.presetItems.forEach((x) => (x.selected = false));

    preset.selected = true;
    this.$store.commit("selectPreset", preset);
    this.$store.commit("clearSceneState");
  }

  private selectPreset(preset: PresetMenuItem) {
    if (preset.type == PresetType.NEW) {
      this.panel = 1;
      var inner = this.presets.presetItems.filter(
        (x) => x.type == PresetType.PRESET && x.step == PresetStep.INNER
      );
      if (inner.length) {
        this.setPreset(inner[0], false);
      }
    } else {
      this.setPreset(preset, true);
    }
  }

  private get canLoadPresets(): boolean {
    return (
      this.$store.getters.scene.productLoaded &&
      this.$store.getters.scene.presetsLoaded
    );
  }

  private getPanelNumeration(i: number): number {
    return (
      2 +
      i +
      (this.$store.getters.product.canAddInsides ? 1 : 0) +
      (this.$store.getters.product.canAddFronts ? 1 : 0)
    );
  }

  private elementsPanelClick() {
    var hasAnyFronts = this.$store.getters.scene.elements.filter(
      (x: any) => x.type === ElementType.FRONT
    ).length;
    if (
      this.panel !== 1 &&
      this.$store.getters.scene.areFrontsVisible &&
      hasAnyFronts
    ) {
      this.$store.commit("setFrontsVisibility", false);
      const text = this.$t("hideFronts").toString();
      messager.info(text);
    }
  }

  private frontPanelClick() {
    if (this.panel !== 2 && !this.$store.getters.scene.areFrontsVisible) {
      this.$store.commit("setFrontsVisibility", true);
    }
  }

  private panelClick(section, index) {
    var hasAnyFronts =
      this.$store.getters.scene.elements.filter(
        (x: any) => x.type === ElementType.FRONT
      ).length > 0;
    if (
      (section.type === SectionType.SHELF_COLOR ||
        section.type === SectionType.WALL_COLOR) &&
      this.$store.getters.scene.areFrontsVisible &&
      hasAnyFronts
    ) {
      this.$store.commit("setFrontsVisibility", false);
      // const text = this.$t("hideFronts").toString();
      // messager.info(text);
    }
    if (
      (section.type === SectionType.FRONT_COLOR ||
        section.type === SectionType.HANDLES) &&
      !this.$store.getters.scene.areFrontsVisible
    ) {
      this.$store.commit("setFrontsVisibility", true);
    }
  }

  private mounted() {
    this.$store.subscribe((mutation, state) => {
      if (
        mutation.type === "setProductLoaded" ||
        mutation.type === "setPresetsLoaded"
      ) {
        if (
          this.$store.getters.scene.presetsLoaded &&
          this.currentPresets.length === 1
        ) {
          this.$store.commit("hideLoadingScreen");
        }
        if (!this.canLoadPresets) {
          return;
        }
        if (
          this.currentPresets.length > 0 &&
          this.$store.getters.configuration.presetCustomerUrl === ""
        ) {
          const presetIndex = this.$store.getters.configuration.presetIndex;
          const index = this.currentPresets[presetIndex] ? presetIndex : 0;
          this.selectPreset(this.currentPresets[index]);
        }
      }
      if (mutation.type === "resetModel") {
        const inner = this.presets.presetItems.filter(
          (x) => x.type == PresetType.PRESET && x.step == PresetStep.INNER
        );
        if (inner.length > 0) {
          const preset = inner[0];
          this.setPreset(preset, false);
          this.$store.commit("setFrontsVisibility", true);
        }
      }
    });
  }
}
